import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Icon from '@mui/material/Icon';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useDashboardTheme, ACCENT_COLOR, accentBarSx, cardSx, engineStatusMap, eventStatusColor, deriveEventLabel } from '../utils';

function RoomHeader({ roomId, liveState, summary, engineInfo, lastUpdated, loading }) {
  const t = useDashboardTheme();
  const engineRaw = engineInfo?.status || 'INACTIVE';
  const engine = engineStatusMap[engineRaw] || { label: engineRaw, color: 'default' };
  const eventStatus = liveState?.eventStatus || (liveState ? 'unknown' : 'ended');
  const eventLabel = deriveEventLabel(eventStatus);
  const coin = engineInfo?.coins?.[0] || '—';
  const stage = liveState?.stage || '—';
  const presetName = liveState?.betLimitName || summary?.betLimitName || null;
  const presetMinBid = liveState?.betLimitMinBid ?? summary?.betLimitMinBid ?? null;
  const betLimitLabel = presetName
    ? `${presetName}${presetMinBid != null ? ` (min ${Number(presetMinBid).toFixed(8)} BTC)` : ''}`
    : (liveState?.betLimitId || summary?.betLimitId || '—');

  return (
    <Card sx={{ ...cardSx, mb: 3 }}>
      <MDBox sx={accentBarSx} />
      <MDBox sx={{ p: { xs: 2, sm: 3 } }}>
        <MDBox display='flex' justifyContent='space-between' alignItems={{ xs: 'flex-start', sm: 'center' }} flexWrap='wrap' gap={2} mb={1}>
          <MDBox display='flex' alignItems='center' gap={{ xs: 1.5, sm: 2 }}>
            <MDBox
              sx={{
                width: { xs: '40px', sm: '48px' },
                height: { xs: '40px', sm: '48px' },
                borderRadius: '14px',
                background: ACCENT_COLOR,
                boxShadow: '0 4px 12px rgba(226,0,27,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              <Icon sx={{ color: 'white !important', fontSize: '1.5rem !important' }}>dashboard</Icon>
            </MDBox>
            <MDBox>
              <MDTypography variant='h5' fontWeight='bold' sx={{ letterSpacing: '-0.01em', lineHeight: 1.2, fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
                Crypto Express — Room
              </MDTypography>
              <MDTypography variant='body2' color='text' sx={{ opacity: 0.6, fontSize: '0.8rem' }}>
                Preset: {betLimitLabel} &nbsp;|&nbsp; Stage: {stage}
              </MDTypography>
            </MDBox>
          </MDBox>
          <MDBox display='flex' gap={1} alignItems='center' flexWrap='wrap'>
            <Chip label={`Engine: ${engine.label}`} color={engine.color} size='small' sx={{ fontWeight: 600, fontSize: '0.65rem' }} />
            <Chip label={`Event: ${eventLabel}`} color={eventStatusColor[eventStatus] || 'default'} size='small' sx={{ fontWeight: 600, fontSize: '0.65rem' }} />
            <Chip label={`Coin: ${coin}`} variant='outlined' size='small' sx={{ fontSize: '0.65rem' }} />
            {liveState?.betsInLast5Minutes > 0 && (
              <Chip label={`${liveState.betsInLast5Minutes} bids/5min`} color='info' size='small' variant='outlined' sx={{ fontSize: '0.65rem' }} />
            )}
            {lastUpdated && (
              <MDTypography variant='caption' color='text' sx={{ fontSize: '0.7rem', opacity: 0.5 }}>
                Updated: {lastUpdated.toLocaleTimeString()}
              </MDTypography>
            )}
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default RoomHeader;
